<div class="row mb-2">
  <div class="col text-end">
  <button *ngIf="!isDatePresent('DDE')"
          [itButton]="'outline-primary'" [size]="'xs'" class="me-2"
          data-bs-target="#insertDischargeDateModal" data-bs-toggle="modal"
         >
    Inserisci data di dimissione effettiva
  </button>
  <button *ngIf="isDatePresent('DDE')"
          [itButton]="'outline-primary'" [size]="'xs'" class="me-2"
          data-bs-target="#insertDischargeDateModal" data-bs-toggle="modal">
    Aggiorna data dimissione effettiva
  </button>
    <button
      *ngIf="(request.status.code === 'VAL' || request.status.code === 'CPZ') && (!enrollementData?.sendDate || !enrollementData || enrollementData.cancellationDate)"
      [itButton]="'outline-primary'" [size]="'xs'" class="me-2" (click)="send()"
      >
      Invia richiesta ADI
    </button>
    <button
      *ngIf="enrollementData?.sendDate && !enrollementData?.enrollmentDate && !enrollementData?.cancellationDate"
      [itButton]="'outline-danger'" [size]="'xs'" class="me-2" (click)="cancel()">
      Annulla richiesta ADI
    </button>
  </div>
</div>

<it-modal
  #insertDischargeDateModal="itModal"
  alignment="right"
  scrollable="true"
  id="insertDischargeDateModal"
  size="xl"
>
  <ng-container modalTitle>Inserisci o aggiorna Data e Ora di dimissione</ng-container>
  <div class="row">
    <div class="col">
      <app-request-summary [request]="request"></app-request-summary>
    </div>
  </div>
  <div class="row mt-2">
    <div class="col">
      <app-insert-discharge-date-modal (requestConfirmed)="insertDischargeDate($event)" (cancelled)="cancelledCompleteRequest()"></app-insert-discharge-date-modal>
    </div>
  </div>
</it-modal>